import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { PUBLISHINGV2_FRAGMENT } from "./educational-offer-publishing.graphql";
import { type EducationalOfferPublishingProps } from "./educational-offer-publishing.types";
import { DateTimeDisplay } from "../../../../components/DateTimeDisplay";

export const EducationalOfferPublishing = ({
	publishingV2FragmentRef,
}: EducationalOfferPublishingProps) => {
	const { t } = useTranslation("common");
	const publishing = useFragment(PUBLISHINGV2_FRAGMENT, publishingV2FragmentRef ?? null);

	if (!publishing) {
		return <p>{t("educationalOffer.publishing.noHistory")}</p>;
	}

	return (
		<Card>
			<p>
				{t("educationalOffer.publishing.status")}: {publishing.status}
			</p>

			<p>
				{t("educationalOffer.publishing.started")}{" "}
				<DateTimeDisplay value={publishing.initiatedAt} hideTimezone={true} />
			</p>
			{publishing.finishedAt && (
				<p>
					{t("educationalOffer.publishing.finished")}{" "}
					<DateTimeDisplay value={publishing.finishedAt} hideTimezone={true} />
				</p>
			)}

			<h3>{t("educationalOffer.publishing.messagesTitle")}</h3>

			<DataTable
				emptyMessage={t("educationalOffer.publishing.noMessages")}
				value={[...publishing.messages]}
			>
				<Column
					header={t("educationalOffer.publishing.time")}
					body={(item) => <DateTimeDisplay value={item.timestamp} />}
				/>
				<Column field="message" header={t("educationalOffer.publishing.message")} />
				<Column
					field="additionalMessage"
					header={t("educationalOffer.publishing.additionalInformation")}
				/>
			</DataTable>
		</Card>
	);
};
